import { ReactNode } from 'react';
import OrderConditionNavigatorView from './OrderConditionNavigatorView';
import useOrderConditionNavigator from './hooks/useOrderConditionNavigator';

interface OrderConditionNavigatorProps {
  currentConditionId: string;
  children?: ReactNode;
}

const OrderConditionNavigator = ({
  currentConditionId,
  children,
}: OrderConditionNavigatorProps) => {
  const { previous, next } = useOrderConditionNavigator({ currentConditionId });

  return (
    <OrderConditionNavigatorView previous={previous} next={next}>
      {children}
    </OrderConditionNavigatorView>
  );
};

export default OrderConditionNavigator;
